import React from 'react';

const EmailItem = (props) => {
  const sEmpty = {
    backgroundColor: ' #fff',
    verticalAlign: 'middle',
  };

  const s21 = {
    borderTop: '1px solid #e5e5e5',
    borderLeft: '1px solid #e5e5e5',
    fontFamily: 'Open Sans,sans-serif',
  };
  const s22 = {
    textAlign: 'left',
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
    marginBottom: '3px',
    marginLeft: '9px',
  };
  const s24 = {
    textAlign: 'right',
    fontSize: '16px',
    fontFamily: 'Open Sans,sans-serif',
    color: '#080b0f',
    borderTop: '1px solid #e5e5e5',
    borderRight: '1px solid #e5e5e5',
    marginRight: '23px',
    paddingRight: '14px',
  };
  const s25 = {
    border: '1px solid #e5e5e5',
    padding: '15px',
    fontFamily: 'Open Sans,sans-serif',
  };
  /* const s26 = {
    borderLeft: '3px solid  #3e0b6c',
    fontWeight: 600,
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
    color: '#080b0f',
    padding: '6px 0 6px 12px',
  }; */

  const s28 = {
    borderLeft: '3px solid  #3e0b6c',
    fontWeight: 600,
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
    color: '#080b0f',
    padding: '6px 0 6px 12px',
  };
  const s29 = {
    textAlign: 'right',
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
    color: '#6b6d6f',
  };

  const s34 = {
    textAlign: 'right',
    fontSize: '14px',
    fontFamily: 'Open Sans,sans-serif',
    color: '#fff',
    marginRight: '48px',
  };
  return (
    <table style={props.tableStyle} cellPadding="5" cellSpacing="10" id="emailContainer">
      <tbody>
        <tr>
          <th height="40" style={s21}>
            <h2 style={s22}>Status</h2>
          </th>
          <th style={s24}>Refunded</th>
        </tr>
        <tr>
          <td colSpan="2" style={s25}>
            <table style={props.tableStyle} cellPadding="8" cellSpacing="0" id="emailContainer">
              <tbody>
                <tr>
                  <td style={s28}>Amount refunded</td>
                  <td style={s29}>{props.amount}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={sEmpty}>
            <span style={s34}>.</span>
          </td>
          <td style={sEmpty}>
            <span style={s34}>.</span>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default EmailItem;
